import { useEffect } from 'react';

const SITE = import.meta.env.VITE_SITE_URL || 'https://musthost.com.br';

const navigationSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'SiteNavigationElement',
      '@id': `${SITE}/#nav-traders`,
      name: 'VPS Trader',
      url: `${SITE}/traders`,
      description: 'Servidores VPS de ultra-baixa latência para traders no Brasil, Reino Unido e EUA. Compatível com MT4, MT5 e Profit.',
      hasPart: [
        {
          '@type': 'SiteNavigationElement',
          name: 'VPS Trader Brasil — B3',
          url: `${SITE}/vps-trader-br`,
        },
        {
          '@type': 'SiteNavigationElement',
          name: 'VPS Trader Londres — Forex e LSE',
          url: `${SITE}/vps-trader-uk`,
        },
        {
          '@type': 'SiteNavigationElement',
          name: 'VPS Trader EUA — NYSE e NASDAQ',
          url: `${SITE}/vps-trader-us`,
        },
      ],
    },
    {
      '@type': 'SiteNavigationElement',
      '@id': `${SITE}/#nav-pessoal`,
      name: 'VPS Pessoal',
      url: `${SITE}/vps-pessoal`,
      description: 'Servidor VPS pessoal com IP dedicado internacional para sites, automações e projetos. A partir de R$ 49/mês.',
    },
    {
      '@type': 'SiteNavigationElement',
      '@id': `${SITE}/#nav-dev`,
      name: 'VPS Desenvolvedor',
      url: `${SITE}/vps-dev`,
      description: 'VPS com root access, SSD NVMe e escalabilidade para devs. Deploy rápido no Brasil e EUA.',
    },
    {
      '@type': 'SiteNavigationElement',
      '@id': `${SITE}/#nav-empresa`,
      name: 'VPS Empresa',
      url: `${SITE}/vps-empresa`,
      description: 'Nuvem privada, infraestrutura dedicada, SLA 99,5% e suporte premium 24/7 para empresas.',
    },
    {
      '@type': 'SiteNavigationElement',
      '@id': `${SITE}/#nav-data-center`,
      name: 'Data Center',
      url: `${SITE}/data-center`,
      description: 'Infraestrutura Tier III com datacenters no Brasil, Reino Unido e EUA.',
    },
    {
      '@type': 'SiteNavigationElement',
      '@id': `${SITE}/#nav-contato`,
      name: 'Contato',
      url: `${SITE}/contato`,
      description: 'Fale com a equipe musthost para suporte, vendas e consultoria técnica.',
    },
  ],
};

const SCRIPT_ID = 'site-navigation-jsonld';

function injectSchema(id: string, data: object) {
  if (document.getElementById(id)) return;
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export default function SiteNavigationSchema() {
  useEffect(() => {
    injectSchema(SCRIPT_ID, navigationSchema);
  }, []);

  return null;
}